<template>
  <div v-if="discounts?.length || policyDiscounts?.length">
    <div :class="noBorder ? '' : 'border-b'"></div>
    <div :class="noPadding ? '' : 'px-5 md:px-8 pt-2 md:pb-8 sm:pb-8'">
      <h5 v-if="summaryHeading" :class="noPadding ? '' : 'pt-5'" class="text-lg-bold title pb-2">
        {{ summaryHeading }}
      </h5>
      <h5 :class="noPadding ? '' : 'pt-5'" class="text-lg-bold inline-flex title pb-5">
        {{ dictionary.IQ_PolicyDiscountsHeading }}
      </h5>
      <TagList
        :tags="discounts?.length ? discounts : policyDiscounts"
        :tagType="TagTypes.discount"
        :tagSize="TagSize.sm"
      ></TagList>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { IQuote } from '@/interfaces';
import { useI18n } from 'vue-i18n';
import { PaymentFrequency } from '@/enums/payment-frequency';
import { getDiscountsList } from '@/utils/iq-discounts';
import { TagSize, TagTypes } from '@/enums/tag-enums';
import TagList from '@/components/TagList/TagList.vue';

const { t, getLocaleMessage } = useI18n();
const dictionary: Record<string, string> = getLocaleMessage('en') as any;

const props = defineProps<{
  quote?: IQuote;
  summaryHeading?: string;
  showOnlineDiscount?: boolean;
  showOnlineDiscountLast?: boolean;
  noBorder?: boolean;
  policyDiscounts?: string[];
  noPadding?: boolean;
}>();

const policyDiscounts = computed(() => {
  const discounts = [] as string[];
  props.policyDiscounts?.forEach((value: string) => {
    discounts.push(dictionary[value]);
  });
  return discounts;
});

const discounts = computed(() =>
  getDiscountsList({ t, getLocaleMessage }, props.quote!, {
    showAsMonthly: props.quote?.paymentFrequency == PaymentFrequency.Monthly,
    showOnlineDiscount: props.showOnlineDiscount,
    showOnlineDiscountLast: props.showOnlineDiscountLast,
  })
);
</script>
